import constants from '@/app-configs/constants'

export default [
  {
    path: '/debtors/list',
    name: 'debtors-list',
    component: () => import('@/views/debtor/debtors-list/DebtorsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_DEBTORS',
      breadcrumb: [
        {
          text: 'DEBTIA_DEBTORS',
          active: true,
        },
      ],
      action: constants.action.permissionDebtorView,
      resource: constants.resource.debtor,
      companyOnly: true,
    },
  },
  {
    path: '/debtors/edit/:id',
    name: 'debtor-edit',
    component: () => import('@/views/debtor/debtor-edit/DebtorEdit.vue'),
    meta: {
      action: constants.action.permissionDebtorEdit,
      resource: constants.resource.debtor,
      companyOnly: true,
    },
  },
  {
    path: '/debtors/view/:id',
    name: 'debtor-view',
    component: () => import('@/views/debtor/debtor-view/DebtorView.vue'),
    meta: {
      action: constants.action.permissionDebtorEdit,
      resource: constants.resource.debtor,
      companyOnly: true,
    },
  },
  {
    path: '/debtors/add',
    name: 'debtors-add',
    component: () => import('@/views/debtor/debtors-add/DebtorAdd.vue'),
    meta: {
      title: 'Add Debtor',
      action: constants.action.permissionDebtorAdd,
      resource: constants.resource.debtor,
      companyOnly: true,
    },
  },
]
